<script>
	import AnswerComponent from './AnswerComponent.svelte';
	import {uqn} from './stores.js';
</script>

<h2>Answer</h2>
<AnswerComponent uqn={$uqn}/>
<hr>
